export const itemsById = (items) => ({
    items: items.reduce((accumulator, item) => ({
        ...accumulator,
        [item.id]: item
    }), {})
});

export const objectIsEmpty = object => !Object.keys(object).length;

